module.exports = __webpack_public_path__ + "img/acs-min.f860497c.png";